// src/reducers/documentSubmissionReducer.js
import {
  REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL,
  REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_SUCCESS,
  REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_FAILURE,
  UPLOAD_DOCUMENT_FILE,
  UPLOAD_DOCUMENT_FILE_SUCCESS,
  UPLOAD_DOCUMENT_FILE_FAILURE,
  UPLOAD_DOCUMENT_FILE_PROGRESS,
  RESET_DOCUMENT_SUBMISSION_STATE,
} from "../actions/documentSubmissionActions";

const initialState = {
  presignedUrl: null,
  uploadStatus: "idle", // idle | requesting | ready | uploading | success | error
  uploadProgress: 0,
  error: null,
};

const documentSubmissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL:
      return { ...state, uploadStatus: "requesting", error: null };

    case REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_SUCCESS:
      return { ...state, presignedUrl: action.payload, uploadStatus: "ready", error: null };

    case REQUEST_DOCUMENT_SUBMISSION_PRESIGNED_URL_FAILURE:
      return { ...state, uploadStatus: "error", error: action.payload, presignedUrl: null };

    case UPLOAD_DOCUMENT_FILE:
      return { ...state, uploadStatus: "uploading", uploadProgress: 0, error: null };

    case UPLOAD_DOCUMENT_FILE_PROGRESS:
      return { ...state, uploadProgress: action.payload };

    case UPLOAD_DOCUMENT_FILE_SUCCESS:
      return { ...state, uploadStatus: "success", uploadProgress: 100, error: null };

    case UPLOAD_DOCUMENT_FILE_FAILURE:
      return { ...state, uploadStatus: "error", error: action.payload, uploadProgress: 0 };

    case RESET_DOCUMENT_SUBMISSION_STATE:
      return initialState;

    default:
      return state;
  }
};

export default documentSubmissionReducer;
